import { SHRUNK_WIDTH } from '@/config/navBarWidth';

/** Global UI scale for the entire app at 100% browser zoom. */
export const APP_ZOOM = 0.85;

/**
 * Left page padding of every admin portal page.
 *
 * What: Figma (1920px frames) places content at x=150, so the margin is 150px. The app renders
 * at APP_ZOOM (0.85), so the CSS value is 150 * 0.85 = 127.5px.
 * Why: this is the left edge of the content. Do not change it without checking every page.
 */
const PORTAL_LEFT_PADDING_PX = 150 * APP_ZOOM;

/**
 * Right page padding of every admin portal page.
 *
 * What: the left padding minus the fixed menu strip (SHRUNK_WIDTH, 56px).
 * Why: the menu covers the first 56px of the left padding, so the VISIBLE gap from the menu
 * edge to the content is paddingLeft - 56. Using the same reduced value on the right makes the
 * gap from the menu to the content equal the gap from the content to the right screen edge.
 * Constraint: on hover the menu expands OVER the page; the page layout width stays 56px, so
 * this value does not change on hover.
 */
const PORTAL_RIGHT_PADDING_PX = PORTAL_LEFT_PADDING_PX - SHRUNK_WIDTH;

/**
 * Shared outer padding for admin portal pages (~15% tighter than original).
 *
 * Used by ListView, Dashboard, Settings and other pages. Right padding is the left
 * padding minus the menu width (see PORTAL_RIGHT_PADDING_PX). Vertical values are MUI spacing units, not px.
 */
export const PORTAL_LAYOUT = {
  paddingLeft: `${PORTAL_LEFT_PADDING_PX}px`,
  paddingRight: `${PORTAL_RIGHT_PADDING_PX}px`,
  paddingTop: 5.1,
  paddingBottom: 3.4,
  paddingY: 5.1,
} as const;
